import defaultLayout from '../../../layouts/default'

export default {
  path: 'task',
  component: defaultLayout,
  children: [
    {
      path: 'view',
      component: () => import('./view/task.vue'),
      meta: {
        activeMenu: 'task',
        auth: true
      }
    }
  ]
}
